import React, { forwardRef, useState, useEffect } from "react";
import Masker from "vanilla-masker";

import { InputProps } from "../input/input.types";
import { Input } from "../input";
export type Ref = HTMLInputElement;

const formatCurrency = (value?: string | number) => {
  if (!value) return "";

  const normalizedValue = parseFloat(`${value}`).toFixed(2);

  return Masker.toMoney(normalizedValue, {
    precision: 2,
    separator: ",",
    delimiter: ".",
  });
};

export const MoneyInput = forwardRef<Ref, InputProps>(
  ({ prefix, ...props }, ref) => {
    const [value, setValue] = useState(
      formatCurrency(props.defaultValue as string),
    );

    useEffect(() => {
      setValue(formatCurrency(props.defaultValue as string));
    }, [props.defaultValue]);

    const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
      const rawValue = e.target.value;
      const formattedValue = Masker.toMoney(rawValue, {
        precision: 2,
        separator: ",",
        delimiter: ".",
      });
      setValue(formattedValue);
    };

    return (
      <Input
        ref={ref}
        type="text"
        value={value}
        onChange={handleChange}
        prefix={prefix}
        {...props}
      />
    );
  },
);
MoneyInput.displayName = "MoneyInput";
